import { render, staticRenderFns } from "./OriginalCreate.vue?vue&type=template&id=02ee3c22&scoped=true&"
import script from "./OriginalCreate.vue?vue&type=script&lang=js&"
export * from "./OriginalCreate.vue?vue&type=script&lang=js&"
import style0 from "./OriginalCreate.vue?vue&type=style&index=0&id=02ee3c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee3c22",
  null
  
)

export default component.exports